import { ApiUtil } from 'lecom-api';

import { FormEvents } from 'form/events/form_event_handler';
import { generateUUID } from 'utils/uuid';

import { FormStoreValuesSynchronizer } from './helpers'

export default {
	execute
};

function execute(gridFormName, { dataRow, dataRowId }) {
	publishGridEditEvent(gridFormName, dataRowId, dataRow);
	FormStoreValuesSynchronizer.sync(gridFormName, dataRow);

	return {
		formAction: 'update',
		selectedRowId: dataRowId,
		selectedDataRow: dataRow
	};
}

const publishGridEditEvent = (gridFormName, dataRowId, dataRow) => {
	ApiUtil.getFieldAPI(gridFormName)
		.publish(FormEvents.GRID_EDIT, dataRowId, dataRow);
};
